import CourseList from '@/components/courses/CourseList';

export default function CoursesPage() {
  return (
    <div className="min-h-full bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <CourseList />
        </div>
      </div>
    </div>
  );
}

